import { AppBar, Toolbar } from "@mui/material";
import {
	DeleteButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	ResetButton,
	SplitButton,
	SubmitButton,
} from "@websential/cosmic-v20";

import { FC } from "react";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import { formatDateToShow } from "../../../common/Common";

export interface ICalculatedPayrollAdjustmentSetupToolbar {
	// onSubmitCalculatedPayrollAdjustmentButtonClickedHandler: () => void;
	onSubmitOrOverWriteCalculatedPayrollAdjustmentButtonClickedHandler: (selectedItem: any) => void;
	// onPrintCheckOrStubClaculatedOPayrollButtonClickedHandler: (selectedItem: any) => void;
	onEditCalculatedPayrollAdjustmentButtonClicked: () => void;
	// onEmailStubCalculatedPayrollAdjustmentButtonClicked: (selectedItem: any) => void;
	onProcessPayrollClicked: () => void;
	onCancelProcessPayrollClicked: () => void;
	payrollNonCalculatedDataItems: any;
	selectedPayPeriod: any
	payPeriodEndDate: any
	payPeriodStartDate: any
	companyInfo: any;
	calculatedPayrollAdjustmentTableData:any
}

const isDateBetween = (
	target: string,
	start: string,
	end: string
): boolean => {
	const targetDate = new Date(target);
	const startDate = new Date(start);
	const endDate = new Date(end);

	return targetDate >= startDate && targetDate <= endDate;
};

export const CalculatedPayrollAdjustmentSetupToolbar: FC<ICalculatedPayrollAdjustmentSetupToolbar> = ({
	// onSubmitCalculatedPayrollAdjustmentButtonClickedHandler,
	// onPrintCheckOrStubClaculatedOPayrollButtonClickedHandler,
	onEditCalculatedPayrollAdjustmentButtonClicked,
	// onEmailStubCalculatedPayrollAdjustmentButtonClicked,
	onSubmitOrOverWriteCalculatedPayrollAdjustmentButtonClickedHandler,
	onProcessPayrollClicked,
	payrollNonCalculatedDataItems,
	onCancelProcessPayrollClicked,
	selectedPayPeriod,
	payPeriodEndDate,
	payPeriodStartDate,
	companyInfo,
	calculatedPayrollAdjustmentTableData
}) => {
	
	let companyBillingStartDate = companyInfo.billingStartDate ? new Date(companyInfo.billingStartDate) : null;
	const startDate = new Date(payPeriodStartDate);
	const endDate = new Date(payPeriodEndDate);
	// const isCompanyBillingStartDateLiesBetweenLoadedPeriod = companyBillingStartDate && companyBillingStartDate >= startDate && companyBillingStartDate <= endDate
	const isCompanyBillingStartDateLiesBetweenLoadedPeriod = companyBillingStartDate && companyBillingStartDate <= endDate

	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
			}}
		>
			<Toolbar>
				{/* <SplitButton
					options={["Print Check / Stub", "Print Stub Only", "Print Check Only"]}
					onClickHandler={onPrintCheckOrStubClaculatedOPayrollButtonClickedHandler}
					testId="t4-print-button"
				/> */}
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Edit"
					raised
					onClickHandler={onEditCalculatedPayrollAdjustmentButtonClicked}
					style={{ marginLeft: "1rem", marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					// disabled={selectedPayPeriod && selectedPayPeriod.process ? true : false}
				/>
				{/* <EnhancedButtonPrimeReact
					label="Save"
					onClickHandler={onSubmitCalculatedPayrollAdjustmentButtonClickedHandler}
					raised
					severity={EnhancedButtonPrimeReactSeverity.Success}
					style={{ marginRight: "1rem" }}
				/> */}
				{/* {selectedPayPeriod && selectedPayPeriod.process ?
				<EnhancedButtonPrimeReact
					label="Save"
					raised
					onClickHandler={() => onSubmitOrOverWriteCalculatedPayrollAdjustmentButtonClickedHandler('Save')}
					severity={EnhancedButtonPrimeReactSeverity.Success}
				/>:<SplitButton
					options={["Save", "Overwrite"]}
					onClickHandler={onSubmitOrOverWriteCalculatedPayrollAdjustmentButtonClickedHandler}
					testId="t4-print-button"
				/>} */}
				<EnhancedButtonPrimeReact
					label="Overwrite Tax"
					raised
					onClickHandler={() => onSubmitOrOverWriteCalculatedPayrollAdjustmentButtonClickedHandler('Overwrite')}
					severity={EnhancedButtonPrimeReactSeverity.Success}
				/>
				{/* <span>&nbsp;&nbsp;&nbsp;</span> */}
				{/* <SplitButton
					options={["Email Stub", "Email Timesheet"]}
					onClickHandler={onEmailStubCalculatedPayrollAdjustmentButtonClicked}
					testId="t4-print-button"
				/> */}
				{/* {selectedPayPeriod && selectedPayPeriod.process ? <EnhancedButtonPrimeReact
					label="Cancel Post"
					raised
					onClickHandler={onCancelProcessPayrollClicked}
					style={{ marginLeft: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
					disabled={calculatedPayrollAdjustmentTableData && !calculatedPayrollAdjustmentTableData.transactionReadyState}
				/> : isCompanyBillingStartDateLiesBetweenLoadedPeriod && <EnhancedButtonPrimeReact
					label="Post Entry"
					raised
					onClickHandler={onProcessPayrollClicked}
					style={{ marginLeft: "1rem" }}
					disabled={payrollNonCalculatedDataItems && payrollNonCalculatedDataItems.length > 0 ? true :
						calculatedPayrollAdjustmentTableData && !calculatedPayrollAdjustmentTableData.haveBank ? true : false}
				/>} */}
				<EnhancedButtonPrimeReact
					label="Post Entry"
					raised
					onClickHandler={onProcessPayrollClicked}
					style={{ marginLeft: "1rem" }}
					// disabled={payrollNonCalculatedDataItems && payrollNonCalculatedDataItems.length > 0 ? true :
					// 	calculatedPayrollAdjustmentTableData && !calculatedPayrollAdjustmentTableData.haveBank ? true : false}
				/>

				{/* {selectedPayPeriod && selectedPayPeriod.process &&
					<span
						style={{
							fontSize: "0.875rem",
							fontFamily: '"Roboto","Helvetica","Arial",sans-serif',
							fontWeight: 500,
							letterSpacing: "0.00714em",
							// color: "rgba(0, 0, 0, 0.6)",
							color: "#ef4444",
							marginLeft: "1rem"
						}}>
						Payment Date: <b>{formatDateToShow(payPeriodEndDate)}</b>
					</span>} */}
			</Toolbar>
		</AppBar>
	);
};
